/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Measurement } from './Measurement';
import type { User } from './User';
import type { Midi } from './Midi';
import type { SessionDefinition } from './SessionDefinition';
/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    score?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    pitchMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    pitchMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    comfortableMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    comfortableMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    definitionId?: number;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    userId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Session
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    comment?: string | null;
    /**
     * 
     * @type {Midi}
     * @memberof Session
     */
    comfortableMaxNavigation?: Midi;
    /**
     * 
     * @type {Midi}
     * @memberof Session
     */
    comfortableMinNavigation?: Midi;
    /**
     * 
     * @type {SessionDefinition}
     * @memberof Session
     */
    definition?: SessionDefinition;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof Session
     */
    measurements?: Array<Measurement> | null;
    /**
     * 
     * @type {Midi}
     * @memberof Session
     */
    pitchMaxNavigation?: Midi;
    /**
     * 
     * @type {Midi}
     * @memberof Session
     */
    pitchMinNavigation?: Midi;
    /**
     * 
     * @type {User}
     * @memberof Session
     */
    user?: User;
}

/**
 * Check if a given object implements the Session interface.
 */
export function instanceOfSession(value: object): value is Session {
    return true;
}

export function SessionFromJSON(json: any): Session {
    return SessionFromJSONTyped(json, false);
}

export function SessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Session {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'score': json['score'] == null ? undefined : json['score'],
        'pitchMin': json['pitchMin'] == null ? undefined : json['pitchMin'],
        'pitchMax': json['pitchMax'] == null ? undefined : json['pitchMax'],
        'comfortableMin': json['comfortableMin'] == null ? undefined : json['comfortableMin'],
        'comfortableMax': json['comfortableMax'] == null ? undefined : json['comfortableMax'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'status': json['status'] == null ? undefined : json['status'],
        'data': json['data'] == null ? undefined : json['data'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'comfortableMaxNavigation': json['comfortableMaxNavigation'] == null ? undefined : (require('./Midi') as typeof import('./Midi')).MidiFromJSON(json['comfortableMaxNavigation']),
        'comfortableMinNavigation': json['comfortableMinNavigation'] == null ? undefined : (require('./Midi') as typeof import('./Midi')).MidiFromJSON(json['comfortableMinNavigation']),
        'definition': json['definition'] == null ? undefined : (require('./SessionDefinition') as typeof import('./SessionDefinition')).SessionDefinitionFromJSON(json['definition']),
        'measurements': json['measurements'] == null ? undefined : ((json['measurements'] as Array<any>).map((require('./Measurement') as typeof import('./Measurement')).MeasurementFromJSON)),
        'pitchMaxNavigation': json['pitchMaxNavigation'] == null ? undefined : (require('./Midi') as typeof import('./Midi')).MidiFromJSON(json['pitchMaxNavigation']),
        'pitchMinNavigation': json['pitchMinNavigation'] == null ? undefined : (require('./Midi') as typeof import('./Midi')).MidiFromJSON(json['pitchMinNavigation']),
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function SessionToJSON(json: any): Session {
    return SessionToJSONTyped(json, false);
}

export function SessionToJSONTyped(value?: Session | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'score': value['score'],
        'pitchMin': value['pitchMin'],
        'pitchMax': value['pitchMax'],
        'comfortableMin': value['comfortableMin'],
        'comfortableMax': value['comfortableMax'],
        'definitionId': value['definitionId'],
        'userId': value['userId'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'status': value['status'],
        'data': value['data'],
        'comment': value['comment'],
        'comfortableMaxNavigation': (require('./Midi') as typeof import('./Midi')).MidiToJSON(value['comfortableMaxNavigation']),
        'comfortableMinNavigation': (require('./Midi') as typeof import('./Midi')).MidiToJSON(value['comfortableMinNavigation']),
        'definition': (require('./SessionDefinition') as typeof import('./SessionDefinition')).SessionDefinitionToJSON(value['definition']),
        'measurements': value['measurements'] == null ? undefined : ((value['measurements'] as Array<any>).map((require('./Measurement') as typeof import('./Measurement')).MeasurementToJSON)),
        'pitchMaxNavigation': (require('./Midi') as typeof import('./Midi')).MidiToJSON(value['pitchMaxNavigation']),
        'pitchMinNavigation': (require('./Midi') as typeof import('./Midi')).MidiToJSON(value['pitchMinNavigation']),
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

